
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton } from '@/components';
import { useDuplicateCycleDetail } from '@/modules/duplicate/cycle/model/detail';
import { formatDate, renderOption } from '@/common/utils/helpers';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { DuplicateCycleStatus } from '@/modules/duplicate/cycle/model/mixins';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.CYCLE.DETAIL,
    components: { AppCard, AppButton },
    setup() {
        const { cycle, fetch } = useDuplicateCycleDetail();

        onMounted(async () => {
            await fetch();
        });

        return { cycle, formatDate, renderOption, DuplicateCycleStatus, ROUTE_NAME_DUPLICATE, ROUTE_NAME_GAME };
    }
});
